export const COMMA_SPACE_DELIMITER = ', ';
export const PERIOD_DELIMITER = '.';
export const SPACE_STRING = ' ';
export const DASH_STRING = '-';
export const LOW_DASH_STRING = '_';
